import { gql } from '@apollo/client';

export const GET_CHAT_CONVERSATIONS = gql`
  query GetChatConversationsByCustomerId($input: ChatConversationInput) {
    getChatConversationsByCustomerId(input: $input) {
      count
      data {
        _id
        facebookPageId
        customer
        message
        timestamp
        userId {
          _id
          name
        }
        senderId
        isLiked
        isFailed
        isDeleted
      }
    }
  }
`;